import React, { useEffect } from "react";
import { connect } from "react-redux";

import AccountingExports from "./AccountingExports";
import Menu from "./Menu";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../redux/actions/menuActions";

const AccountingExportsContainer = props => {
  useEffect(() => {
    props.setMenuTopIndex("accounting");
    props.setMenuLeftContent(Menu);
    props.setMenuLeftIndex("export");
    props.setMenuLeftItemIndex("");
  }, []);
  return <AccountingExports {...props} />;
};

const mapStateToProps = state => {
  const currentClient = state.currentClient || {};
  return {
    token: state.auth.token,
    clientLabel: currentClient.label,
    clientId: currentClient.id
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountingExportsContainer);



// WEBPACK FOOTER //
// src/pages/accounting/AccountingExports.container.js